// Empowered Cooks product page: gallery thumbs, Print/PDF format switch, sticky add to cart.

if (!customElements.get('ec-gallery')) {
  customElements.define(
    'ec-gallery',
    class EcGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ec-gallery__track');
        this.thumbs = [...this.querySelectorAll('.ec-gallery__thumb')];
        this.thumbs.forEach((thumb) =>
          thumb.addEventListener('click', () => this.go(Number(thumb.dataset.index)))
        );
        this.track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => this.mark(Math.round(this.track.scrollLeft / this.track.clientWidth)));
        });
      }

      go(index) {
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
        this.mark(index);
      }

      mark(index) {
        this.thumbs.forEach((thumb, i) => thumb.toggleAttribute('aria-current', i === index));
      }
    }
  );
}

if (!customElements.get('ec-format-picker')) {
  customElements.define(
    'ec-format-picker',
    class EcFormatPicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const radio = event.target;
          if (radio.type !== 'radio') return;
          const form = document.getElementById(this.dataset.form);
          if (form) form.querySelector('[name=id]').value = radio.value;

          const section = this.closest('section');
          const set = (selector, text) => {
            section.querySelectorAll(selector).forEach((el) => {
              el.textContent = text;
              el.hidden = !text;
            });
          };
          set('[data-ec-now]', radio.dataset.price);
          set('[data-ec-was]', radio.dataset.was);
          set('[data-ec-save]', radio.dataset.save);
          set('[data-ec-atc-price]', radio.dataset.price);
          set('[data-ec-sticky-price]', radio.dataset.price);
        });
      }
    }
  );
}

if (!customElements.get('ec-sticky-atc')) {
  customElements.define(
    'ec-sticky-atc',
    class EcStickyAtc extends HTMLElement {
      connectedCallback() {
        const target = document.getElementById(this.dataset.target);
        this.querySelector('[data-ec-sticky-add]')?.addEventListener('click', () => {
          document.getElementById(this.dataset.form)?.querySelector('[type=submit]')?.click();
        });
        if (!target) return;
        // Scroll-based so a fast jump past the buy box (anchor link, fling) still shows the bar.
        const update = () => {
          this.hidden = target.getBoundingClientRect().bottom > 0;
        };
        window.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
        update();
      }
    }
  );
}

if (!customElements.get('ec-plan-picker')) {
  customElements.define(
    'ec-plan-picker',
    class EcPlanPicker extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          const radio = event.target;
          if (radio.type !== 'radio') return;
          const form = document.getElementById(this.dataset.form);
          if (!form) return;
          form.querySelector('[name=id]').value = radio.dataset.variant;
          form.querySelector('[name=selling_plan]').value = radio.dataset.plan;

          const section = this.closest('section');
          const terms = section.querySelector('[data-ec-plan-terms]');
          if (terms) terms.textContent = radio.dataset.terms;
          section.querySelectorAll('[data-ec-plan-button]').forEach((el) => {
            el.textContent = radio.dataset.button;
          });
        });
      }
    }
  );
}

// Optional add-ons under the buy button: added to the cart first, then the normal product form runs
if (!customElements.get('ec-product-addons')) {
  customElements.define(
    'ec-product-addons',
    class EcProductAddons extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        this.printRow = this.querySelector('[data-ec-addon-print]');
        if (!this.form) return;
        this.form.addEventListener('submit', this.onSubmit.bind(this), true);
        document.querySelectorAll('ec-format-picker[data-form="' + this.dataset.form + '"] input[type="radio"]').forEach((radio) => {
          radio.addEventListener('change', this.syncFormat.bind(this));
        });
      }

      syncFormat(event) {
        if (!this.printRow) return;
        const isPrint = event.target.value === this.dataset.print;
        this.printRow.hidden = !isPrint;
        if (!isPrint) this.printRow.querySelector('[data-ec-addon-check]').checked = false;
      }

      selectedItems() {
        return [...this.querySelectorAll('.ec-addon')]
          .filter((row) => row.querySelector('[data-ec-addon-check]').checked)
          .map((row) => {
            const field = row.querySelector('[data-ec-addon-variant]');
            const item = { id: Number(field.value), quantity: 1 };
            if (field.dataset.plan) item.selling_plan = Number(field.dataset.plan);
            return item;
          });
      }

      onSubmit(event) {
        if (this.adding) return;
        const items = this.selectedItems();
        if (!items.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.adding = true;
        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .catch((error) => console.error(error))
          .finally(() => {
            this.querySelectorAll('[data-ec-addon-check]').forEach((check) => (check.checked = false));
            this.form.requestSubmit();
            this.adding = false;
          });
      }
    }
  );
}

// Lower "Get the course" buttons: add to cart with the page's main buy form instead of only scrolling up
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-ec-buy]');
  if (!trigger) return;
  const buy = document.querySelector('main product-form button[type="submit"][name="add"]:not([disabled])');
  if (!buy) return;
  event.preventDefault();
  buy.click();
});
